// import './wdyr'
import { createRoot } from 'react-dom/client'
import { I18nextProvider } from 'react-i18next'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { QueryClientProvider } from '@tanstack/react-query'
import {
  browserTracingIntegration,
  extraErrorDataIntegration,
  init as SentryInit,
  setTag,
} from '@sentry/react'
import { ToastContainer } from 'react-toastify'
import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider } from '@mui/material/styles'
import i18next from './i18next'
import { queryClient } from './api'
import App from './App'
import theme from './theme'
import './styles.css'
import { LicenseInfo } from '@mui/x-license'
import { StrictMode } from 'react'

const {
  MODE,
  VITE_SENTRY_DSN,
  VITE_SENTRY_ENVIRONMENT = 'localhost',
  VITE_SENTRY_RELEASE,
  VITE_MUI_LICENCE_KEY,
} = import.meta.env

// Setup Sentry for errors reporting in production
setTag('APP_TYPE', MODE) // public or admin
SentryInit({
  dsn: VITE_SENTRY_DSN,
  tracePropagationTargets: ['permonik.nkp.cz', 'permonik-test.nkp.cz', /^\//],
  integrations: [browserTracingIntegration(), extraErrorDataIntegration()],
  tracesSampleRate: 0.5,
  environment: VITE_SENTRY_ENVIRONMENT,
  release: VITE_SENTRY_RELEASE,
  beforeSend(event) {
    return VITE_SENTRY_ENVIRONMENT === 'localhost' ? null : event
  },
})

LicenseInfo.setLicenseKey(VITE_MUI_LICENCE_KEY)

createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <I18nextProvider i18n={i18next}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <App />
        </ThemeProvider>
      </I18nextProvider>
      <ReactQueryDevtools buttonPosition="bottom-right" />
    </QueryClientProvider>
    <ToastContainer
      position="bottom-left"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
    />
  </StrictMode>
)
